import { Resource } from "src/app/core/jsonapi/resource";
import { WorkerBankAccount } from "./worker-bank-account";
import { prop, propArray, propObject, required } from "@rxweb/reactive-form-validators";
import { User } from "../../users/_types/user";
import { WorkerZone } from "./worker-zone";
import { WorkerCapability } from "./worker-capability";
import { WorkerGuardShift } from "./worker-guard-shift";
import { Address } from "../../common/_types/address";
import { Delegation } from "../../common/_types/delegation";
import { ProfessionalCategory } from "../../common/_types/professional-category";

export class Worker extends Resource {
    public override type = 'workers';

    @prop()
    public externalId?: string;

    @prop()
    public typeOfWorker: string = "Accidents";

    @prop()
    public description!: string;

    @prop()
    public oldDescription?: string;

    @prop()
    @required()
    public name!: string;
    
    @prop()
    public legalName!: string;
    @prop()
    public typeOfBusiness: string = "Person";
    @prop()
    public notes!: string;
    @prop()
    public email!: string;
    @prop()
    public phone1!: string;
    @prop()
    public phone2!: string;
    @prop()
    public active: boolean = true;
    @prop()
    public vatNumber!: string;

    @prop()
    public bankAccountId?: string;
    @prop()
    public calendarId!: string;

    @prop()
    public parentWorkerId!: string;

    @prop()
    public parentWorker!: Worker;

    @prop()
    public hasBankAccount: boolean = false;

    @propObject(WorkerBankAccount)
    public bankAccount!: WorkerBankAccount;

    @prop()
    public addressId!: string;

    @propObject(Address)
    public address: Address = new Address();

    @prop()
    public userId!: string;

    @prop()
    public enableAccess: boolean = false;

    @prop()
    public hasGuardShiftEnabled: boolean = false;

    /*@prop()
    public guardShiftId!: string;*/

    @prop()
    public usePrincipalAddressAsWorkStart: boolean = true;

    @prop()
    public manageYourAppointments: boolean = false;

    @prop()
    public maxUnconfirmedServices!: number;

    @prop()
    public hasSubmitInvoice: boolean = false;

    @prop()
    public workStartAddressId!: string;

    @prop()
    public rating!: number;

    @propObject(Address)
    public workStartAddress?: Address;

    @propObject(User)
    public user?: User;

    @prop()
    public allZones: boolean = false;

    @propArray()
    public workerZones: WorkerZone[] = [];

    @propArray()
    public workerCapabilities: WorkerCapability[] = [];

    @prop()
    public workload?: number;

    @prop()
    public latitude?: number | null;

    @prop()
    public longitude?: number | null;

    @prop()
    public lastPositionDate?: Date | null;

    @prop()
    public endDate!: Date | null;

    @prop()
    public workerEndReasonId!: string;

    @prop()
    public endNotes!: string;

    @propArray()
    public workerGuardShifts: WorkerGuardShift[] = [];

    @prop()
    public paymentMethodId!: string;

    @prop()
    public paymentDay?: number;
    
    @prop()
    public allowRegisterServiceOffTheClock: boolean = false;

    @prop()
    public hoursCaseService:number = 2;

    @prop()
    public economicNotes?: string;

    @prop()
    public sendCaseServiceByEmail: boolean = false;

    
    //@prop()
    //public isStaff: boolean = false;

    @prop()
    public socialSecurityNumber?: string;

    
    @prop()
    public professionalCategoryId?: string;
    
    @propObject(ProfessionalCategory)
    public professionalCategory?: ProfessionalCategory;

    
    @prop()
    public delegationId?: string;
    
    @propObject(Delegation)
    public delegation?: Delegation;

}